<template>
  <section class="card poste-soins-unites" aria-label="Poste de soins">
    <div class="card-body">
      <header class="psu-entete">
        <div>
          <div class="psu-titre">
            <h3 class="c-title">Hospitalisation · poste de soins</h3>
            <button type="button" class="psu-actualiser" title="Actualiser le poste de soins" aria-label="Actualiser le poste de soins" :disabled="actualisation" @click="actualiser">
              <i class="fa fa-sync-alt" :class="{ 'fa-spin': actualisation }" aria-hidden="true"></i>
            </button>
          </div>
          <p>Accueillez les transferts des unités, installez les patients, suivez les soins puis préparez les sorties.</p>
        </div>
        <div class="psu-actions">
          <span v-if="aAccueillir" class="psu-alerte" role="status"><span class="psu-point" aria-hidden="true"></span>{{ aAccueillir }} à accueillir</span>
          <router-link class="psu-secondaire" to="/occupation-lits">Occupation des lits</router-link>
        </div>
      </header>
      <TransfertsServices ref="unites" @compteur="nombre => { aAccueillir = nombre }" @arrivee="actualiserPoste" />
      <PosteSoins ref="poste" class="psu-poste" />
    </div>
  </section>
</template>

<script>
import PosteSoins from './poste-soins'
import TransfertsServices from './transferts-services.vue'

// Une seule carte (04/10/2026) : unités et transferts (à accueillir, présents) au-dessus des onglets du poste de soins
// (en attente de lit, hospitalisés, soins à administrer, sorties prévues), sans dupliquer le poste de soins.
export default {
  name: 'poste-soins-unites',
  components: { PosteSoins, TransfertsServices },
  data() {
    return { aAccueillir: 0, actualisation: false }
  },
  methods: {
    actualiserPoste() {
      if (this.$refs.poste && typeof this.$refs.poste.refresh === 'function') return this.$refs.poste.refresh()
      return null
    },
    async actualiser() {
      if (this.actualisation) return
      this.actualisation = true
      try {
        await Promise.all([this.$refs.unites ? this.$refs.unites.charger() : null, this.actualiserPoste()])
      } finally {
        this.actualisation = false
      }
    },
  },
}
</script>

<style scoped>
.poste-soins-unites { margin-bottom: 1.5rem; border: 0; border-radius: 22px; box-shadow: none; color: var(--ui-text, #172033); }
.poste-soins-unites > .card-body { padding: 26px 30px; }
.psu-entete { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; flex-wrap: wrap; margin-bottom: 14px; }
.psu-titre { display: flex; align-items: center; gap: 12px; }
.psu-titre .c-title { margin: 0; color: var(--ui-text, #172033); font-weight: 700; }
.psu-entete p { margin: 6px 0 0; color: var(--ui-text-secondary, #273449); }
.psu-actions { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; }
.psu-alerte { display: inline-flex; align-items: center; gap: 8px; min-height: 38px; padding: 7px 16px; border-radius: 999px; background: #fff0f0; color: #9b2626; font-weight: 700; font-size: 14px; }
.psu-point { width: 9px; height: 9px; border-radius: 50%; background: #c62828; animation: psu-clignote 1.2s ease-in-out infinite; }
.psu-secondaire { display: inline-flex; align-items: center; min-height: 38px; padding: 7px 16px; border: 1px solid #c7d5f1; border-radius: 999px; background: #fff; color: var(--ui-accent, #2457c5); font-weight: 600; white-space: nowrap; }
.psu-secondaire:hover { background: #eaf0ff; text-decoration: none; }
.psu-actualiser { display: inline-flex; align-items: center; justify-content: center; width: 38px; height: 38px; border: 1px solid #c7d5f1; border-radius: 12px; background: #fff; color: var(--ui-accent, #2457c5); }
.psu-actualiser:hover { background: #eaf0ff; }
.psu-actualiser:disabled { cursor: wait; }
.poste-soins-unites button:focus-visible, .poste-soins-unites a:focus-visible { outline: 3px solid #8caaf5; outline-offset: 2px; }
@keyframes psu-clignote { 0%, 100% { opacity: 1; } 50% { opacity: .35; } }
@media (prefers-reduced-motion: reduce) { .psu-point { animation: none; } }
@media (max-width: 700px) { .poste-soins-unites > .card-body { padding: 18px 16px; } }
</style>

<style>
/* Le poste de soins s'intègre dans cette carte : sans sa propre carte ni son en-tête (repris ci-dessus). */
.poste-soins-unites .psu-poste.poste-soins { margin: 0; border: 0; box-shadow: none; background: transparent; }
.poste-soins-unites .psu-poste.poste-soins > .card-body { padding: 0; }
.poste-soins-unites .psu-poste.poste-soins .poste-head { display: none !important; }
</style>
